import React from 'react';
import styled from 'styled-components';
import media from '../styles/media';


const layout = props => (
    <LayoutWrapper>
        {props.children}
    </LayoutWrapper>
)

const LayoutWrapper = styled.div`

    ${media.mobileS`
        margin-top: 193px;
        height: 100%;
        width: 100%;

    `}

    ${media.tablet`
        margin-top: 160px;
    `}

`

export default layout;